import React, { useState, useRef } from "react";
import { ProgressBarProps } from "./TabProgressBar.type";
import { Tooltip } from 'react-tooltip';
import {
  BorderBottom,
  CheckCircleFill,
  Circle,
  CircleFill,
} from "react-bootstrap-icons";

export const ProgressBar: React.FC<ProgressBarProps> = ({
  tabs,
  handleNext,
  currentTab,
}) => {
  // const handlePrevious = () => {
  //   setCurrentTab((prevTab) => Math.max(prevTab - 1, 0));
  // };

  return (
    <div>
      <Tooltip id="my-tooltip" />
      <div className="px-4 bg-white rounded-top">
        <ul className="nav">
          {tabs.map((item, index) => (
            <li
              key={index}
              className={`tab-item col-auto`}
              style={{
                borderBottom: index <= currentTab ? "3px solid #29afe8" : "",
              }}
            >
              <div className="mx-2 d-flex align-items-center text-truncate">
                {index < currentTab ? (
                  <span className="nav-link completed" data-tooltip-id="my-tooltip" data-tooltip-content={item.label}>
                    <span>
                      <CheckCircleFill />
                    </span>{" "}
                    {item.label}
                  </span>
                ) : index === currentTab ? (
                  <span className="nav-link active"  data-tooltip-id="my-tooltip" data-tooltip-content={item.label}>
                    <span>
                      <Circle />
                    </span>{" "}
                    {item.label}
                  </span>
                ) : (
                  <span className="nav-link" data-tooltip-id="my-tooltip" data-tooltip-content={item.label}>
                    <span>
                      <CircleFill />
                    </span>{" "}
                    {item.label}
                  </span>
                )}
              </div>
            </li>
          ))}
        </ul>

        {/* <button
          onClick={handlePrevious}
          disabled={currentTab === 0}
          style={{ display: "none" }}
        >
          Previous
        </button> */}
        <button
          id="createClientNextButton" // ID assigned to the Next button
          onClick={() => {
            handleNext();
          }}
          disabled={currentTab === tabs.length - 1}
          style={{ display: "none" }}
        >
          Next
        </button>
      </div>
      <div>{tabs[currentTab].content}</div>
    </div>
  );
};

export default ProgressBar;
